import { Allocation } from 'api';
import { FundOwnership } from 'common/types/fundOwnership';
import { FundOwnershipTableData } from 'pages/CapTable/fund-ownership/models/fund-ownership.models';
import { FundOwnershipCapTable } from 'pages/CapTable/fund-ownership/types';

export const initialTableData: FundOwnershipTableData = {
  capTable: {} as FundOwnershipCapTable,
  acquisitions: [],
  capTableVersionsByCompany: {},
  allocation: {} as Allocation,
  fundOwnership: {} as FundOwnership & { deleted_fund_ownership_details: number[] },
  calculations: {},
};

export const tableTerms = {
  tableName: 'Fund Ownership',
  tableSlug: 'fund-ownership',
  columnName: 'Ownership',
  pluralColumnName: 'Ownerships',
};

export const fundOwnershipDetailsTraverser = 'fundOwnership.fund_ownership_detail';

export const FIXED_DECIMAL_PLACES = 2;

export const RELATED_ENTITY_ALLOCATION_TOOLTIP_TITLE =
  'Related Entity Allocation: Proceeds and economics flow through the related entity\'s allocation and cap table.';
